import { makeStyles, css } from '@conexasaude/conexa-hero'

const useStyles = makeStyles({
  wrapper: ({ spacing }) => css`
    margin-top: ${spacing.xs};
  `,
})

export { useStyles }
